<script>
import { GravyPath, PackagingPath, TicketsPath, ImagesPath } from "@/path";
import axios from "axios";
import SelectWithSearch from "../../Common/SelectWithSearch.vue";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  components: { SelectWithSearch },
  data() {
    return {
      selected_issue: null,
      supplyIssueOptions: [
        {
          value: null,
          text: "Select Issue",
        },
        {
          value: "expired",
          text: "Expired",
        },
        {
          value: "wrong_item",
          text: "Wrong Items",
        },
        {
          value: "missing_item/qty",
          text: "Missing Items/Qty",
        },
        {
          value: "damaged_item/pkg",
          text: "Damaged Items/Packagings",
        },
        {
          value: "excess_qty",
          text: "Return Excess Quantity",
        },
        {
          value: "dicontinued_items",
          text: "Return Discontinued Items",
        },
        {
          value: "non_moving_items",
          text: "Return Non Moving Items",
        },
      ],
      selected_order: null,
      order_list: [],
      orders: [],
      all_gravies: [],
      all_packagings: [],
      restaurant_gravies: [],
      restaurant_packagings: [],
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      cdn: process.env.VUE_APP_AWS_CDN,
      expiredItemsFields: ["name", "qty", "image"],
      discontinuedItemsFields: ["name", "qty"],
      selectedExpiredItems: [],
      expired_gravy_ids: [],
      wrongItemsFields: ["name", "qty_received"],
      selectedWrongItems: [],
      wrong_gravy_ids: [],
      missingQuantityFields: ["name", "qty_billed", "qty_received"],
      damagedQuantityFields: ["name", "qty_billed", "qty_damaged", "images"],
      selectedMissingItems: [],
      orderMissingGraviesList: [],
      orderMissingPackagingList: [],
      missing_gravy_ids: [],
      files: [],
      uploaded_file_path: [],
      showSelectedIssueAlert: false,
      showSelectedExpiredItemsAlert: false,
      showSelectedWrongItemsAlert: false,
      showSelectedMissingItemsAlert: false,
      showSelectedDamagedItemsAlert: false,
      showSelectedDamagedItemsImagesAlert: false,
      showSelectedExpiredItemsImagesAlert: false,
      showMissingQtyAlert: false,
      key: 1,
      imgKey: 1,
    };
  },
  computed: {
    GravyPath() {
      return GravyPath;
    },
    PackagingPath() {
      return PackagingPath;
    },
    TicketsPath() {
      return TicketsPath;
    },
  },
  watch: {
    expired_gravy_ids(v) {
      this.showSelectedExpiredItemsAlert = false;
      this.filterExpiredGravies(v);
    },
    wrong_gravy_ids(v) {
      this.showSelectedWrongItemsAlert = false;
      this.filterWrongGravies(v);
    },
    missing_gravy_ids(v) {
      this.key += this.key;
      this.showSelectedMissingItemsAlert = false;
      this.showSelectedDamagedItemsAlert = false;
      this.filterMissingGravies(v);
    },
    selected_issue() {
      this.showSelectedIssueAlert = false;
      this.showSelectedExpiredItemsAlert = false;
      this.showSelectedWrongItemsAlert = false;
      this.showSelectedDamagedItemsAlert = false;
      this.showSelectedDamagedItemsImagesAlert = false;
      this.showSelectedExpiredItemsImagesAlert = false;
      this.showMissingQtyAlert = false;
      this.selected_order = null;
      this.selectedExpiredItems = [];
      this.selectedWrongItems = [];
      this.selectedMissingItems = [];
      if (
        this.selected_issue == "dicontinued_items" ||
        this.selected_issue == "expired" ||
        this.selected_issue == "non_moving_items"
      ) {
        this.getRestaurantGravies();
      }
      if (this.selected_issue == "missing_item/qty") {
        this.missingQuantityFields = ["name", "qty_billed", "qty_received"];
      } else if (this.selected_issue == "excess_qty") {
        this.missingQuantityFields = ["name", "qty_billed", "return_qty"];
      }
    },
    selected_order() {
      this.selectedWrongItems = [];
      this.selectedMissingItems = [];
      if (
        this.selected_issue == "missing_item/qty" ||
        this.selected_issue == "damaged_item/pkg" ||
        this.selected_issue == "excess_qty"
      ) {
        this.getOrderGravies();
        this.getOrderPackagings();
      }
    },
    selectedMissingItems() {},
  },
  mounted() {
    this.getAllGravies();
    this.getAllPackagings();
    this.getRestaurantPackagings();
    this.getOrders();
  },
  methods: {
    async getAllGravies() {
      try {
        let res = await axios.get(this.baseUrl + TicketsPath.FETCH_GRAVIES);
        if (res.data.status) {
          this.all_gravies = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getRestaurantGravies() {
      let data = {};
      if (this.selected_issue == "dicontinued_items") {
        data = {
          trashed: true,
        };
      } else {
        data = {
          trashed: true,
          // res_id: this.$store.state.authfack.user.restaurant.id,
        };
      }
      try {
        let res = await axios.get(this.baseUrl + TicketsPath.FETCH_GRAVIES, {
          params: data,
        });
        if (res.data.status) {
          this.restaurant_gravies = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getAllPackagings() {
      try {
        let res = await axios.get(this.baseUrl + TicketsPath.FETCH_PACKAGING);

        if (res.data.status) {
          this.all_packagings = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getRestaurantPackagings() {
      try {
        let res = await axios.get(this.baseUrl + TicketsPath.FETCH_PACKAGING, {
          params: {
            res_id: this.$store.state.authfack.user.restaurant.id,
          },
        });
        if (res.data.status) {
          this.restaurant_packagings = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getOrders() {
      try {
        let res = await axios.get(this.baseUrl + TicketsPath.FETCH_ORDERS);

        if (res.data.status) {
          this.orders = res.data.data;
          res.data.data.forEach((f) => {
            if (this.getNoOfDays(f.expected_delivery_date) <= 3) {
              this.order_list.push({
                value: f.ref_id,
                text:
                  moment(f.expected_delivery_date).format("DD-MM-YYYY") +
                  " - " +
                  f.ref_id,
              });
            }
          });
          this.order_list = [
            { value: null, text: "Select an Order" },
            ...this.order_list,
          ];
        }
      } catch (e) {
        console.log(e);
      }
    },
    getNoOfDays(date) {
      const date1 = new Date(date);
      const date2 = new Date();

      const diffTime = Math.abs(date2 - date1);

      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays;
    },
    async getBarcodeGravies() {
      try {
        let res = await axios.get(this.baseUrl + GravyPath.GRAVY_ORDER_LEVEL, {
          params: {
            brand_id: this.selected_brand,
            res_id: this.form.res_id ? this.form.res_id : this.restaurant?.id,
            daterange: this.projection_date,
            barcode: this.barcode,
          },
        });
        if (res.data.status) {
          let d = res.data.data.data[0];
          let check = this.form.gravies.findIndex(
            (f) => f.id == d.id && f.batch_code == d.gravy_batch[0].batch_code
          );
          if (check !== -1) {
            this.form.gravies[check].qty_to_ship += 1;
          } else {
            d.qty_to_ship = 1;
            d.batch_code = d.gravy_batch[0].batch_code;
            delete d.gravy_batch;
            this.form.gravies.unshift(d);
            this.orderGraviestotalRows = this.form.gravies.length;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    // What the order was actually billed on, per stage:
    //   delivered, or a GRN already submitted -> qty_delivered, the counted
    //     quantity. A 0 here is a real count meaning nothing arrived.
    //   shipped / stock_out -> qty_shipped. qty_delivered is NOT written at ship
    //     time (only at the deliver step or by a GRN), so reading it here would
    //     cap every claim at 0 and make missing/excess tickets unraisable.
    //   pending / accepted -> qty_to_ship, nothing has left the warehouse.
    billedQty(orderItems) {
      if (!orderItems) {
        return 0;
      }
      const order = this.orders.find((o) => o.ref_id === this.selected_order);
      const status = order && order.order_status;
      let qty;
      if (status === "delivered" || (order && order.grn_submitted_at)) {
        qty = orderItems.qty_delivered;
      } else if (status === "shipped" || status === "stock_out") {
        qty = orderItems.qty_shipped;
      } else {
        qty = orderItems.qty_to_ship;
      }
      return qty != null ? Number(qty) : 0;
    },
    async getOrderGravies() {
      let orderId;
      this.orders.forEach((order) => {
        if (this.selected_order == order.ref_id) {
          orderId = order.id;
        }
      });
      try {
        let res = await axios.get(this.baseUrl + TicketsPath.FETCH_GRAVIES, {
          params: {
            get_qty: true,
            order_id: orderId,
          },
        });
        if (res.data.status) {
          this.orderMissingGraviesList = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getOrderPackagings() {
      let orderId;
      this.orders.forEach((order) => {
        if (this.selected_order == order.ref_id) {
          orderId = order.id;
        }
      });
      try {
        let res = await axios.get(this.baseUrl + TicketsPath.FETCH_PACKAGING, {
          params: {
            get_qty: true,
            order_id: orderId,
          },
        });
        if (res.data.status) {
          this.orderMissingPackagingList = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async saveFile(e, i) {
      this.files.push(e.target.files[0]);
      try {
        let formData = new FormData();
        formData.append("file", e.target.files[0]);
        formData.append("folder", "tickets");
        let res = await axios.post(
          this.baseUrl + ImagesPath.UPLOAD_IMAGE,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status) {
          if (!this.uploaded_file_path[i]) {
            this.uploaded_file_path[i] = [res.data.data.file];
          } else {
            this.uploaded_file_path[i] = [
              ...this.uploaded_file_path[i],
              res.data.data.file,
            ];
          }
        }
        this.key += 1;
      } catch (err) {
        console.log(err);
      }
    },
    filterExpiredGravies(v) {
      const exists = this.selectedExpiredItems.some(
        (item) => item.name === v.name
      );
      console.log(v, "iii");

      if (!exists) {
        this.selectedExpiredItems.push({
          id: v.id,
          name: v.name,
          type: v.type,
          units: v.type == "gravy" ? v.units : v.uom,
          uom: v.type == "gravy" ? v.uom : v.units,
          expired_qty: 1,
          expired_pcs: 0,
        });
      }
    },
    minusExpiredQty(v, u) {
      if (u) {
        if (v.expired_pcs == 1 && v.expired_qty == 0) {
          this.selectedExpiredItems = this.selectedExpiredItems.filter(
            (item) => {
              return v.name != item.name;
            }
          );
        }
        this.selectedExpiredItems.forEach((item) => {
          if (item.name == v.name) {
            item.expired_pcs -= 1;
          }
        });
      } else {
        if (v.expired_qty == 1 && v.expired_pcs == 0) {
          this.selectedExpiredItems = this.selectedExpiredItems.filter(
            (item) => {
              return v.name != item.name;
            }
          );
        }
        this.selectedExpiredItems.forEach((item) => {
          if (item.name == v.name) {
            item.expired_qty -= 1;
          }
        });
      }
    },
    setExpiredQty(e, v, u) {
      this.selectedExpiredItems.forEach((item) => {
        if (item.name == v.name) {
          u ? (item.expired_pcs = Number(e)) : (item.expired_qty = Number(e));
        }
      });
    },
    addExpiredQty(v, u) {
      this.selectedExpiredItems.forEach((item) => {
        if (item.name == v.name) {
          u ? (item.expired_pcs += 1) : (item.expired_qty += 1);
        }
      });
    },
    filterWrongGravies(v) {
      const exists = this.selectedWrongItems.some((item) => item.name === v);

      if (!exists) {
        this.selectedWrongItems.push({
          id: v.id,
          name: v.name,
          type: v.type,
          units: v.type == "gravy" ? v.units : v.uom,
          uom: v.type == "gravy" ? v.uom : v.units,
          qty_received: 1,
          pcs_received: 0,
        });
      }
    },
    minusWrongItemQty(v, u) {
      if (u) {
        if (v.pcs_received == 1 && v.qty_received == 0) {
          this.selectedWrongItems = this.selectedWrongItems.filter((item) => {
            return v.name != item.name;
          });
        }
        this.selectedWrongItems.forEach((item) => {
          if (item.name == v.name) {
            item.pcs_received -= 1;
          }
        });
      } else {
        if (v.qty_received == 1 && v.pcs_received == 0) {
          this.selectedWrongItems = this.selectedWrongItems.filter((item) => {
            return v.name != item.name;
          });
        }
        this.selectedWrongItems.forEach((item) => {
          if (item.name == v.name) {
            item.qty_received -= 1;
          }
        });
      }
    },
    setWrongItemQty(e, v, u) {
      this.selectedWrongItems.forEach((item) => {
        if (item.name == v.name) {
          u ? (item.pcs_received = Number(e)) : (item.qty_received = Number(e));
        }
      });
    },
    addWrongItemQty(v, u) {
      this.selectedWrongItems.forEach((item) => {
        if (item.name == v.name) {
          u ? (item.pcs_received += 1) : (item.qty_received += 1);
        }
      });
    },
    filterMissingGravies(v) {
      if (this.selectedMissingItems.some((item) => item.name === v.name))
        return;

      if (this.selected_issue === "damaged_item/pkg") {
        this.selectedMissingItems.push({
          id: v.id,
          name: v.name,
          units: v.type === "gravy" ? v.units : v.uom,
          uom: v.type === "packaging" ? v.uom : v.units,
          type: v.type,
          qty_received: 1,
          pcs_received: 0,
        });
        return;
      }

      const { gravy_id, packaging_id } = v.order_items;
      const isGravy = gravy_id != null;
      const qtyBilled = this.billedQty(v.order_items);

      const baseItem = {
        id: isGravy ? gravy_id : packaging_id,
        name: v.name,
        units: isGravy ? v.units : v.uom,
        uom: isGravy ? v.uom : v.units,
        type: isGravy ? "gravy" : "packaging",
      };

      if (this.selected_issue === "missing_item/qty") {
        this.selectedMissingItems.push({
          ...baseItem,
          qty_billed: qtyBilled,
          qty_received: 0,
          pcs_received: 0,
        });
      } else if (this.selected_issue === "excess_qty") {
        this.selectedMissingItems.push({
          ...baseItem,
          qty_billed: qtyBilled,
          return_qty: 1,
          return_pcs: 0,
        });
      }
    },
    minusMissingItemQty(v, type) {
      this.selectedMissingItems = this.selectedMissingItems.filter((item) => {
        if (item.name !== v.name) return true;

        switch (this.selected_issue) {
          case "damaged_item/pkg":
            if (v.qty_received === 1) {
              this.missing_gravy_ids = null;
              return false;
            }
            item.qty_received -= 1;
            return true;

          case "excess_qty":
            if (type === "pcs" && v.return_pcs === 1 && v.return_qty === 0) {
              this.missing_gravy_ids = null;
              return false;
            }
            if (type !== "pcs" && v.return_qty === 1 && v.return_pcs === 0) {
              this.missing_gravy_ids = null;
              return false;
            }
            type === "pcs" ? item.return_pcs-- : item.return_qty--;
            return true;

          case "missing_item/qty":
            type === "pcs" ? item.qty_received-- : item.pcs_received--;
            return true;
        }
      });
    },
    setMissingItemQty(e, v, type) {
      const item = this.selectedMissingItems.find(
        (item) => item.name === v.name
      );
      if (!item) return;

      const value = Number(e);

      if (type !== "pcs" && value >= v.qty_billed) {
        this.showMissingQtyAlert = true;
        if (this.selected_issue === "missing_item/qty") {
          item.qty_received = 0;
        } else if (this.selected_issue === "excess_qty") {
          item.return_qty = 1;
        }
        this.key += 1;
        return;
      }

      if (this.selected_issue === "excess_qty") {
        type === "pcs" ? (item.return_pcs = value) : (item.return_qty = value);
      }

      type === "pcs"
        ? (item.pcs_received = value)
        : (item.qty_received = value);
    },
    addMissingItemQty(v, type) {
      if (this.selected_issue == "missing_item/qty") {
        const totalReceived =
          v.qty_received + v.pcs_received / v.uom + (type === "pcs" ? 0.1 : 1);

        if (totalReceived >= v.qty_billed) {
          this.selectedMissingItems = this.selectedMissingItems.filter(
            (item) => item.name !== v.name
          );
        }
      }
      if (this.selected_issue == "damaged_item/pkg") {
        if (v.qty_received == v.qty_billed) {
          return;
        }
      }
      if (this.selected_issue == "excess_qty") {
        if (v.return_qty + v.return_pcs / v.uom == v.qty_billed) {
          return;
        }
      }
      this.selectedMissingItems.forEach((item) => {
        if (item.name == v.name) {
          if (type == "pcs") {
            if (this.selected_issue == "excess_qty") {
              item.return_pcs += 1;
            } else {
              item.pcs_received += 1;
            }
          } else {
            if (this.selected_issue == "excess_qty") {
              item.return_qty += 1;
            } else {
              item.qty_received += 1;
            }
          }
        }
      });
    },

    removeImage(index, i) {
      this.uploaded_file_path[index].splice(i, 1);
      this.imgKey++;
    },
    async saveTicket() {
      let details = { issue: this.selected_issue, order: this.selected_order };
      if (!this.selected_issue) {
        this.showSelectedIssueAlert = true;
        return;
      }
      if (
        this.selected_issue == "expired" ||
        this.selected_issue == "dicontinued_items" ||
        this.selected_issue == "non_moving_items"
      ) {
        if (this.selectedExpiredItems.length == 0) {
          this.showSelectedExpiredItemsAlert = true;
          return;
        }
        details.items = this.selectedExpiredItems.map((item) => {
          return {
            id: item.id,
            name: item.name,
            units: item.units,
            uom: item.uom,
            type: item.type,
            expired_qty: item.expired_qty,
            expired_pcs: item.expired_pcs,
          };
        });
        details.images = this.uploaded_file_path;
        if (
          this.selected_issue == "expired" ||
          this.selected_issue == "non_moving_items"
        ) {
          let uploadedImages = true;
          this.selectedExpiredItems.forEach((ele, ind) => {
            if (!this.uploaded_file_path[ind]) {
              this.showSelectedExpiredItemsImagesAlert = true;
              uploadedImages = false;
              return;
            }
          });
          if (!uploadedImages) {
            return;
          }
        }
      } else if (this.selected_issue == "wrong_item") {
        if (this.selectedWrongItems.length == 0) {
          this.showSelectedWrongItemsAlert = true;
          return;
        }
        details.items = this.selectedWrongItems;
      } else if (
        this.selected_issue == "missing_item/qty" ||
        this.selected_issue == "excess_qty"
      ) {
        if (this.selectedMissingItems.length == 0) {
          this.showSelectedMissingItemsAlert = true;
          return;
        }
        details.items = this.selectedMissingItems;
      } else if (this.selected_issue == "damaged_item/pkg") {
        if (this.selectedMissingItems.length == 0) {
          this.showSelectedDamagedItemsAlert = true;
          return;
        }
        details.items = this.selectedMissingItems;
        details.images = this.uploaded_file_path;
        let uploadedImages = true;
        this.selectedMissingItems.forEach((ele, ind) => {
          if (!this.uploaded_file_path[ind]) {
            this.showSelectedDamagedItemsImagesAlert = true;
            uploadedImages = false;
            return;
          }
        });
        if (!uploadedImages) {
          return;
        }
      }
      try {
        let res = await axios.post(this.baseUrl + TicketsPath.SAVE_TICKET, {
          category: "supply",
          extra_details: details,
        });
        if (res.data.status) {
          Swal.fire("Ticket Raised Successfully", "", "success").then(() => {
            this.$router.push("/tickets_dashboard");
          });
        } else {
          throw new Error("Failed to save");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<template>
  <div>
    <b-row style="color: black; font-size: 16px">
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-form-group label="Select Issue:">
          <b-form-select
            v-model="selected_issue"
            :options="supplyIssueOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col
        sm="8"
        md="6"
        lg="6"
        xl="4"
        v-if="
          selected_issue == 'wrong_item' ||
          selected_issue == 'missing_item/qty' ||
          selected_issue == 'excess_qty'
        "
      >
        <b-form-group label="Orders:">
          <b-form-select
            v-model="selected_order"
            :options="order_list"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col
        sm="8"
        md="6"
        lg="6"
        xl="4"
        v-if="
          selected_issue == 'expired' ||
          selected_issue == 'dicontinued_items' ||
          selected_issue == 'non_moving_items'
        "
      >
        <b-form-group label="Search Gravies:">
          <select-with-search
            :search_without_api="true"
            track_by="name"
            display="name"
            full_object="true"
            :optionsData="restaurant_gravies"
            @selectedOption="
              (v) => {
                expired_gravy_ids = { ...v, type: 'gravy' };
              }
            "
          ></select-with-search>
        </b-form-group>
      </b-col>
      <b-col
        sm="8"
        md="6"
        lg="6"
        xl="4"
        v-if="selected_issue == 'dicontinued_items'"
      >
        <b-form-group label="Search Packagings:">
          <select-with-search
            :search_without_api="true"
            track_by="name"
            display="name"
            full_object="true"
            :optionsData="restaurant_packagings"
            @selectedOption="
              (v) => {
                expired_gravy_ids = { ...v, type: 'packaging' };
              }
            "
          ></select-with-search>
        </b-form-group>
      </b-col>
      <b-col
        sm="8"
        md="6"
        lg="6"
        xl="4"
        v-if="selected_issue == 'wrong_item' && selected_order"
      >
        <b-form-group label="Search Gravies:">
          <select-with-search
            :search_without_api="true"
            track_by="name"
            display="name"
            full_object="true"
            :optionsData="all_gravies"
            @selectedOption="
              (v) => {
                wrong_gravy_ids = { ...v, type: 'gravy' };
              }
            "
          ></select-with-search>
        </b-form-group>
      </b-col>
      <b-col
        sm="8"
        md="6"
        lg="6"
        xl="4"
        v-if="selected_issue == 'wrong_item' && selected_order"
      >
        <b-form-group label="Search Packagings:">
          <select-with-search
            :search_without_api="true"
            track_by="name"
            display="name"
            full_object="true"
            :optionsData="all_packagings"
            @selectedOption="
              (v) => {
                wrong_gravy_ids = { ...v, type: 'packaging' };
              }
            "
          ></select-with-search>
        </b-form-group>
      </b-col>
      <b-col
        sm="8"
        md="6"
        lg="6"
        xl="4"
        v-if="selected_issue == 'damaged_item/pkg'"
      >
        <b-form-group label="Search Gravies:">
          <select-with-search
            :search_without_api="true"
            track_by="id"
            display="name"
            selected_by="id"
            :full_object="true"
            :optionsData="all_gravies"
            @selectedOption="
              (v) => {
                missing_gravy_ids = { ...v, type: 'gravy' };
              }
            "
            :key="key"
          ></select-with-search>
        </b-form-group>
      </b-col>
      <b-col
        sm="8"
        md="6"
        lg="6"
        xl="4"
        v-if="
          (selected_issue == 'missing_item/qty' ||
            selected_issue == 'excess_qty') &&
          selected_order
        "
      >
        <b-form-group label="Search Gravies:">
          <select-with-search
            :search_without_api="true"
            track_by="id"
            display="name"
            selected_by="id"
            :full_object="true"
            :optionsData="orderMissingGraviesList"
            @selectedOption="
              (v) => {
                missing_gravy_ids = v;
              }
            "
            :key="key"
          ></select-with-search>
        </b-form-group>
      </b-col>
      <b-col
        sm="8"
        md="6"
        lg="6"
        xl="4"
        v-if="selected_issue == 'damaged_item/pkg'"
      >
        <b-form-group label="Search Packagings:">
          <select-with-search
            :search_without_api="true"
            track_by="id"
            display="name"
            selected_by="id"
            :full_object="true"
            :optionsData="all_packagings"
            @selectedOption="
              (v) => {
                missing_gravy_ids = { ...v, type: 'packaging' };
              }
            "
            :key="key"
          ></select-with-search>
        </b-form-group>
      </b-col>
      <b-col
        sm="8"
        md="6"
        lg="6"
        xl="4"
        v-if="
          (selected_issue == 'missing_item/qty' ||
            selected_issue == 'excess_qty') &&
          selected_order
        "
      >
        <b-form-group label="Search Packagings:">
          <select-with-search
            :search_without_api="true"
            track_by="id"
            display="name"
            selected_by="id"
            :full_object="true"
            :optionsData="orderMissingPackagingList"
            @selectedOption="
              (v) => {
                missing_gravy_ids = v;
              }
            "
            :key="key"
          ></select-with-search>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      v-if="
        order_list.length == 1 &&
        (selected_issue == 'wrong_item' ||
          selected_issue == 'missing_item/qty' ||
          selected_issue == 'damaged_item/pkg' ||
          selected_issue == 'excess_qty')
      "
    >
      <b-col sm="8" md="6" lg="6" xl="4">
        <p style="color: black">
          <span style="color: red"> *</span> No Orders delivered in last 2 days
        </p>
      </b-col>
    </b-row>
    <b-row v-if="!selected_issue">
      <b-col sm="8" md="6" lg="6" xl="6">
        <div
          style="
            background-color: rgb(240, 240, 240);
            border-radius: 10px;
            padding: 10px;
            font-size: 16px;
            word-spacing: 6px;
          "
        >
          Note:- <br />
          <br />
          Select Expired if any item in stock is expired. <br /><br />
          Select Wrong Item if you receive any item that is not mentioned in the
          Order. <br /><br />
          Select Missing Items/Qty if you did not receive any item or as per
          mentioned Qty in the Order.
        </div>
      </b-col>
    </b-row>
    <b-table
      :fields="expiredItemsFields"
      :items="selectedExpiredItems"
      v-if="
        (selected_issue == 'expired' || selected_issue == 'non_moving_items') &&
        selectedExpiredItems.length
      "
      :key="key"
    >
      <template v-slot:cell(qty)="row">
        <div style="display: flex; flex-direction: column; gap: 4px">
          <div style="display: flex; align-items: center; gap: 5px">
            <div>
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="minusExpiredQty(row.item)"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  :key="row.item.name"
                  :value="row.item.expired_qty"
                  min="0"
                  @input="setExpiredQty($event, row.item)"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="addExpiredQty(row.item)"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <p>Pkts</p>
          </div>
          <div
            style="display: flex; align-items: center; gap: 5px"
            v-if="row.item.units == 'pcs'"
          >
            <div>
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="minusExpiredQty(row.item, 'pcs')"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  :key="row.item.name"
                  :value="row.item.expired_pcs"
                  min="0"
                  @input="setExpiredQty($event, row.item, 'pcs')"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="addExpiredQty(row.item, 'pcs')"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <p>Pcs</p>
          </div>
          <div v-if="row.item.units == 'pcs'">
            Total:{{
              (
                row.item.expired_qty +
                row.item.expired_pcs / row.item.uom
              ).toFixed(2)
            }}
          </div>
        </div>
      </template>
      <template v-slot:cell(image)="row">
        <div>
          <b-form-group label="Please Click a Picture and Upload:">
            <b-form-file
              accept="image/*"
              @change="saveFile($event, row.index)"
              multiple
            ></b-form-file>
          </b-form-group>
        </div>
        <div
          v-if="uploaded_file_path[row.index]?.length"
          style="display: flex; flex-wrap: wrap; gap: 10px"
        >
          <div
            v-for="(file, i) in uploaded_file_path[row.index]"
            :key="i"
            style="position: relative"
          >
            <img
              src="./x-circle.svg"
              alt="X Circle"
              style="
                margin: 0px;
                padding: 0px;
                position: absolute;
                right: 0px;
                top: 0px;
                background-color: white;
                border-radius: 50%;
              "
              class="remove-img"
              @click="removeImage(row.index, i)"
              :key="imgKey"
            />
            <img
              :src="cdn + '/' + file"
              alt="some"
              height="100px"
              style="
                margin-left: 5px;
                box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
              "
            />
          </div>
        </div>
      </template>
    </b-table>
    <b-table
      :fields="discontinuedItemsFields"
      :items="selectedExpiredItems"
      v-if="
        selected_issue == 'dicontinued_items' && selectedExpiredItems.length
      "
    >
      <template v-slot:cell(qty)="row">
        <div style="display: flex; flex-direction: column; gap: 4px">
          <div style="display: flex; align-items: center; gap: 5px">
            <div>
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="minusExpiredQty(row.item)"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  :key="row.item.name"
                  :value="row.item.expired_qty"
                  min="0"
                  @input="setExpiredQty($event, row.item)"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="addExpiredQty(row.item)"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <p>Pkts</p>
          </div>
          <div
            style="display: flex; align-items: center; gap: 5px"
            v-if="row.item.units == 'pcs'"
          >
            <div>
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="minusExpiredQty(row.item, 'pcs')"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  :key="row.item.name"
                  :value="row.item.expired_pcs"
                  min="0"
                  @input="setExpiredQty($event, row.item, 'pcs')"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="addExpiredQty(row.item, 'pcs')"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <p>Pcs</p>
          </div>
          <div v-if="row.item.units == 'pcs'">
            Total:
            <span style="color: black">
              {{
                (
                  row.item.expired_qty +
                  row.item.expired_pcs / row.item.uom
                ).toFixed(2)
              }}
            </span>
            Pkts
          </div>
        </div>
      </template>
    </b-table>
    <b-table
      :fields="wrongItemsFields"
      :items="selectedWrongItems"
      v-if="selected_issue == 'wrong_item' && selectedWrongItems.length"
    >
      <template v-slot:cell(qty_received)="row">
        <div style="display: flex; flex-direction: column; gap: 4px">
          <div style="display: flex; align-items: center; gap: 5px">
            <div>
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="minusWrongItemQty(row.item)"
                    size="sm"
                    variant="primary"
                    :disabled="row.item.qty_received == 0"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  :key="row.item.id"
                  :value="row.item.qty_received"
                  min="0"
                  @input="setWrongItemQty($event, row.item)"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="addWrongItemQty(row.item)"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <p>Pkts</p>
          </div>
          <div
            style="display: flex; align-items: center; gap: 5px"
            v-if="row.item.units == 'pcs'"
          >
            <div>
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="minusWrongItemQty(row.item, 'pcs')"
                    size="sm"
                    variant="primary"
                    :disabled="row.item.pcs_received == 0"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  :key="row.item.id"
                  :value="row.item.pcs_received"
                  min="0"
                  @input="setWrongItemQty($event, row.item, 'pcs')"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="addWrongItemQty(row.item, 'pcs')"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <p>Pcs</p>
          </div>
          <div v-if="row.item.units == 'pcs'">
            Total :
            <span style="color: black">
              {{
                (
                  row.item.qty_received +
                  row.item.pcs_received / row.item.uom
                ).toFixed(2)
              }}
            </span>
            Pkts
          </div>
        </div>
      </template>
    </b-table>
    <b-table
      :key="key"
      :fields="missingQuantityFields"
      :items="selectedMissingItems"
      v-if="
        (selected_issue == 'missing_item/qty' ||
          selected_issue == 'excess_qty') &&
        selectedMissingItems.length
      "
    >
      <template v-slot:cell(return_qty)="row">
        <div style="display: flex; flex-direction: column; gap: 4px">
          <div style="display: flex; align-items: center; gap: 5px">
            <div>
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="minusMissingItemQty(row.item)"
                    size="sm"
                    variant="primary"
                    :disabled="row.item.return_qty == 0"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  :key="row.item.id"
                  :value="row.item.return_qty"
                  min="0"
                  @input="setMissingItemQty($event, row.item)"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="addMissingItemQty(row.item)"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <p>Pkts</p>
          </div>
          <div
            style="display: flex; align-items: center; gap: 5px"
            v-if="row.item.units == 'pcs'"
          >
            <div>
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="minusMissingItemQty(row.item, 'pcs')"
                    size="sm"
                    variant="primary"
                    :disabled="row.item.return_pcs == 0"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  :key="row.item.id"
                  :value="row.item.return_pcs"
                  min="0"
                  @input="setMissingItemQty($event, row.item, 'pcs')"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="addMissingItemQty(row.item, 'pcs')"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <p>Pcs</p>
          </div>
          <div v-if="row.item.units == 'pcs'">
            Total :
            <span style="color: black">
              {{
                (
                  row.item.return_qty +
                  row.item.return_pcs / row.item.uom
                ).toFixed(2)
              }}
            </span>
            Pkts
          </div>
        </div>
      </template>
      <template v-slot:cell(qty_received)="row">
        <div style="display: flex; flex-direction: column; gap: 4px">
          <div style="display: flex; align-items: center; gap: 5px">
            <div>
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="minusMissingItemQty(row.item)"
                    size="sm"
                    variant="primary"
                    :disabled="row.item.qty_received == 0"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  :key="row.item.id"
                  :value="row.item.qty_received"
                  min="0"
                  @input="setMissingItemQty($event, row.item)"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="addMissingItemQty(row.item)"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <p>Pkts</p>
          </div>
          <div
            style="display: flex; align-items: center; gap: 5px"
            v-if="row.item.units == 'pcs'"
          >
            <div>
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="minusMissingItemQty(row.item, 'pcs')"
                    size="sm"
                    variant="primary"
                    :disabled="row.item.pcs_received == 0"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  :key="row.item.id"
                  :value="row.item.pcs_received"
                  min="0"
                  @input="setMissingItemQty($event, row.item, 'pcs')"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="addMissingItemQty(row.item, 'pcs')"
                    size="sm"
                    variant="primary"
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <p>Pcs</p>
          </div>
          <div v-if="row.item.units == 'pcs'">
            Total:
            {{
              (
                row.item.qty_received +
                row.item.pcs_received / row.item.uom
              ).toFixed(2)
            }}
          </div>
        </div>
      </template>
    </b-table>
    <b-row
      v-if="selected_issue == 'damaged_item/pkg' && selectedMissingItems.length"
      style="display: flex"
      :key="key"
    >
      <b-col
        sm="8"
        md="6"
        lg="6"
        xl="4"
        v-for="(item, index) in selectedMissingItems"
        :key="index"
      >
        <b-card>
          <p style="font-size: 16px; color: black">
            {{ item.name }}
          </p>
          <div
            style="
              display: flex;
              justify-content: space-between;
              padding-inline: 15px;
              color: gray;
              margin-top: 10px;
              margin-bottom: 10px;
            "
          >
            <div style="margin: auto">
              <p style="padding-bottom: 10px">Damaged Qty</p>
              <div
                style="
                  text-align: center;
                  color: black;
                  display: flex;
                  justify-content: center;
                  gap: 10px;
                  align-items: center;
                "
              >
                <span
                  @click="minusMissingItemQty(item)"
                  style="cursor: pointer"
                >
                  <i class="fa fa-minus" style="color: grey"></i>
                </span>
                <b-form-input
                  v-model="item.qty_received"
                  @input="setMissingItemQty($event, item)"
                  style="width: 60px; text-align: center"
                ></b-form-input>
                <span @click="addMissingItemQty(item)" style="cursor: pointer">
                  <i class="fa fa-plus" style="color: grey"></i>
                </span>
              </div>
            </div>
          </div>
          <div>
            <b-form-group label="Please Click a Picture and Upload:">
              <b-form-file
                accept="image/*"
                @change="saveFile($event, index)"
                multiple
              ></b-form-file>
            </b-form-group>
          </div>
          <div
            v-if="uploaded_file_path[index]?.length"
            style="display: flex; flex-wrap: wrap; gap: 10px"
          >
            <div
              v-for="(file, i) in uploaded_file_path[index]"
              :key="i"
              style="position: relative"
            >
              <img
                src="./x-circle.svg"
                alt="X Circle"
                style="
                  margin: 0px;
                  padding: 0px;
                  position: absolute;
                  right: 0px;
                  top: 0px;
                  background-color: white;
                  border-radius: 50%;
                "
                class="remove-img"
                @click="removeImage(index, i)"
                :key="imgKey"
              />
              <img
                :src="cdn + '/' + file"
                alt="some"
                height="100px"
                style="
                  margin-left: 5px;
                  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
                "
              />
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-table
      :key="key"
      :fields="damagedQuantityFields"
      :items="selectedMissingItems"
      v-if="false"
    >
      <template v-slot:cell(qty_damaged)="row">
        <b-input-group style="width: 130px">
          <b-input-group-prepend>
            <b-button
              @click="minusMissingItemQty(row.item)"
              size="sm"
              variant="primary"
              :disabled="row.item.qty_received == 0"
              ><i class="fa fa-minus"></i
            ></b-button>
          </b-input-group-prepend>
          <b-form-input
            type="number"
            :key="row.item.id"
            :value="row.item.qty_received"
            min="0"
            @input="setMissingItemQty($event, row.item)"
          ></b-form-input>
          <b-input-group-append>
            <b-button
              @click="addMissingItemQty(row.item)"
              size="sm"
              variant="primary"
              ><i class="fa fa-plus"></i
            ></b-button>
          </b-input-group-append>
        </b-input-group>
      </template>
    </b-table>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert v-model="showMissingQtyAlert" variant="danger" dismissible>
          {{
            selected_issue == "missing_item/qty"
              ? "Received Qty"
              : selected_issue == "excess_qty"
              ? "Excess Qty"
              : "Damaged Qty"
          }}
          cannot be greater than Billed Qty
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert v-model="showSelectedIssueAlert" variant="danger" dismissible>
          Please Select Issue and Items to Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert
          v-model="showSelectedExpiredItemsAlert"
          variant="danger"
          dismissible
        >
          Please select
          {{
            selected_issue == "expired"
              ? "Expired"
              : selected_issue == "non_moving_items"
              ? "Non Moving"
              : "Discontinued"
          }}
          Items to Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert
          v-model="showSelectedWrongItemsAlert"
          variant="danger"
          dismissible
        >
          Please select Wrong Items Sent to Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert
          v-model="showSelectedMissingItemsAlert"
          variant="danger"
          dismissible
        >
          Please select Missing Items to Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert
          v-model="showSelectedDamagedItemsAlert"
          variant="danger"
          dismissible
        >
          Please select Damaged Items to Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert
          v-model="showSelectedDamagedItemsImagesAlert"
          variant="danger"
          dismissible
        >
          Please upload the images of damaged items and Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert
          v-model="showSelectedExpiredItemsImagesAlert"
          variant="danger"
          dismissible
        >
          Please upload the images of
          {{ selected_issue == "expired" ? "expired" : "non moving" }}
          items and Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row style="margin-bottom: 100px" class="text-right text-sm-left">
      <b-col>
        <b-button
          variant="primary"
          class="mt-2"
          @click="saveTicket"
          :disabled="
            order_list.length == 1 &&
            (selected_issue == 'wrong_item' ||
              selected_issue == 'missing_item/qty' ||
              selected_issue == 'damaged_item/pkg' ||
              selected_issue == 'excess_qty')
          "
          >Raise Ticket</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<style>
.remove-img:hover {
  cursor: pointer;
}
</style>
